export default __webpack_public_path__ + "static/media/step3-2.16e466e6.png";